import { useEffect } from 'react'
import { Advantages } from './containers/advantages/advantages'
import { Benefits } from './containers/benefits/benefits'
import { Calculation } from './containers/calculation/calculation'
import { Contact } from './containers/contact/contact'
import { Main } from './containers/main/main'
import { Reviews } from './containers/reviews/reviews'
import { Services } from './containers/services/Services'
import { Footer } from 'layout/components/footer/footer'

import qualibat from 'assets/qualibat.webp'

export interface ReviewProps {
    author_name: string;
    profile_photo_url: string;
    rating: number;
    text: string;
}

export const HARDCODED_REVIEWS: ReviewProps[] = [
    {
        author_name: 'Laetitia USAÏ MATON',
        profile_photo_url: '',
        rating: 5,
        text: "Travail rapide et bien, équipe très professionnelle et serieuse rien à dire merci",
    },
    {
        author_name: 'Alain Guinoiseau',
        profile_photo_url: '',
        rating: 5,
        text: "L'isolation de notre maison par l'extérieur est appréciable, les travaux se sont très biens déroulés, les ouvriers sont complémentaires et efficaces, le rendu est parfait...",
    },
    {
        author_name: 'Emy',
        profile_photo_url: '',
        rating: 5,
        text: "Travail sérieux et soigné. Je recontacterai cette entreprise pour mes futurs projets.",
    },
    {
        author_name: 'Maria MATENCU',
        profile_photo_url: '',
        rating: 5,
        text: "Entreprise très sérieuse, le dirigeant vous accompagne du début à la fin du projet. Les techniciens sont très gentils et surtout à l'écoute du client. Travail soigné et rapide!!",
    },
    {
        author_name: 'François Tavernier',
        profile_photo_url: '',
        rating: 5,
        text: "Nous avons effectué plusieurs rénovations globales avec l'intervention de cette entreprise. Je recommande sans aucune hésitation, le travail est sérieux et soigné!",
    },
    {
        author_name: 'GIRARD Audrey',
        profile_photo_url: '',
        rating: 5,
        text: "Contente de mes installations (isolation extérieure + clim réversible + ballon d'eau chaude thermodynamique) : personnes compétentes, rapides et facilité pour les joindre pour la moindre question.",
    },
];

export const HARDCODED_RATING = 5;
export const HARDCODED_RATINGS_TOTAL = 6;

export const Home = () => {

    useEffect(() => {
        document.title = 'Postica Rénovation - Entreprise de rénovation et construction'
    }, [])

    return (
        <>
            <Main />
            <div className='max-w-7xl mx-auto'>
                <Advantages />
            </div>
            <Services />
            <Benefits />
            <Calculation gray />
            <div className='max-w-7xl mx-auto py-16 px-4'>
                <div className='flex flex-col-reverse md:flex-row items-center text-center md:text-start'>
                    <div>
                        <h1 className='text-4xl z-20'>Nous sommes certifiés Qualibat</h1>
                        <h3 className='mt-2 text-lg'>Grâce à notre certification Qualibat RGE, vous pouvez avoir confiance en notre savoir-faire et en notre capacité à réaliser des travaux de haute qualité, dans le respect des normes environnementales les plus exigeantes.</h3>
                    </div>
                    <img className='max-w-[250px] mt-4 md:mt-0' src={qualibat} alt='qualibat' />
                </div>
            </div>
            <Contact gray />
            <Reviews reviews={HARDCODED_REVIEWS} />
            <Footer rating={HARDCODED_RATING} user_ratings_total={HARDCODED_RATINGS_TOTAL} />
        </>
    )
}